import DispatchOnRouteChange from './DispatchOnRouteChange';


export default DispatchOnRouteChange;
